import { trackUsage } from '../../../deferred/analytics/NavUsageTrackers';
export const trackUpgradeButtonClick = () => {
  trackUsage('upgradesInteraction', {
    action: 'viewed upgrade point',
    upgradeKey: 'global-nav-bar',
    source: 'global-nav-bar'
  });
};